var map = {
	"./1.png": 9734,
	"./2.png": 1357,
	"./3.png": 1412,
	"./4.png": 3067,
	"./5.png": 8850,
	"./6.png": 9561,
	"./7.png": 4736,
	"./8.png": 8967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5500;